import { apiRequest } from '../apiRequest';

export const organisationsMetricsAPI = {
  getDashboardMetrics: async (orgId, params: any = {}) => {
    const search = new URLSearchParams();
    if (params.deploymentDays != null) search.set('deploymentDays', String(params.deploymentDays));
    if (params.leadDays != null) search.set('leadDays', String(params.leadDays));
    if (params.churnDays != null) search.set('churnDays', String(params.churnDays));
    if (params.cycleDays != null) search.set('cycleDays', String(params.cycleDays));
    if (params.includeLabelDora === false) search.set('includeLabelDora', '0');
    const qs = search.toString();
    const data = await apiRequest<any>(
      `/api/organisations/${orgId}/dashboard-metrics${qs ? `?${qs}` : ''}`,
      { method: 'GET' }
    );
    return {
      dora: data.dora ?? { deployment: null, lead: null },
      churn: data.churn ?? { dates: [], ratios: [] },
      cycleTime: data.cycleTime ?? { cycleTime: null, meta: null },
      labelDora: data.labelDora ?? null,
      labelMeta: data.labelMeta ?? null,
    };
  },
  getDora: async (orgId, windowDays = 30) => {
    const params = new URLSearchParams({ windowDays: String(windowDays) });
    const data = await apiRequest<any>(`/api/organisations/${orgId}/dora?${params}`, { method: 'GET' });
    return { dora: data.dora, meta: data.meta };
  },
  getDoraLabelMetrics: async (orgId, options: any = {}) => {
    const params = new URLSearchParams();
    if (options.windowDays != null) params.set('windowDays', String(options.windowDays));
    if (options.granularity === 'week') params.set('granularity', 'week');
    if (options.repositoryId) params.set('repositoryId', String(options.repositoryId));
    const qs = params.toString();
    const data = await apiRequest<any>(
      `/api/organisations/${orgId}/dora-label-metrics${qs ? `?${qs}` : ''}`,
      { method: 'GET' }
    );
    return { labelDora: data.labelDora, meta: data.meta };
  },
  getCycleTime: async (orgId, options: any = {}) => {
    const params = new URLSearchParams();
    if (options.windowDays != null) params.set('windowDays', String(options.windowDays));
    if (options.repositoryId) params.set('repositoryId', String(options.repositoryId));
    const qs = params.toString();
    const data = await apiRequest<any>(`/api/organisations/${orgId}/cycle-time${qs ? `?${qs}` : ''}`, {
      method: 'GET',
    });
    return { cycleTime: data.cycleTime, meta: data.meta };
  },
  getCodeComposition: async (orgId, options: any = {}) => {
    const params = new URLSearchParams();
    if (options.windowDays != null) params.set('windowDays', String(options.windowDays));
    if (options.repositoryId) params.set('repositoryId', String(options.repositoryId));
    if (options.projectId) params.set('projectId', String(options.projectId));
    if (options.streamId) params.set('streamId', String(options.streamId));
    if (options.period === 'weekly' || options.period === 'monthly') {
      params.set('period', options.period);
    }
    const qs = params.toString();
    const data = await apiRequest<any>(
      `/api/organisations/${orgId}/code-composition${qs ? `?${qs}` : ''}`,
      { method: 'GET' }
    );
    return {
      composition: data.composition ?? null,
      compositionByPeriod: data.compositionByPeriod ?? null,
    };
  },
  getChurn: async (orgId, windowDays = 30) => {
    const params = new URLSearchParams({ windowDays: String(windowDays) });
    const data = await apiRequest<any>(`/api/organisations/${orgId}/churn?${params}`, { method: 'GET' });
    const churn = data.churn ?? data;
    return { dates: churn.dates ?? [], ratios: churn.ratios ?? [] };
  },
  getMemberChurn: async (orgId, memberId, windowDays = 30) => {
    const params = new URLSearchParams({ windowDays: String(windowDays) });
    const data = await apiRequest<any>(
      `/api/organisations/${orgId}/members/${encodeURIComponent(memberId)}/churn?${params}`,
      { method: 'GET' }
    );
    const churn = data.churn ?? data;
    return { dates: churn.dates ?? [], ratios: churn.ratios ?? [] };
  },
};
